import { history } from '@umijs/max';
import { message, notification } from 'antd';
import axios from 'axios';
import Qs from 'qs';
// import {
//   useRequestEnvironment,
//   useRequestParams,
//   useResponseAutoLogin,
//   useResponseData,
// } from './middleware';

const instance = axios.create({
    timeout: 120000,
    headers: {
        'Content-Type': 'application/json',
    },
    baseURL:
        import.meta.env.MODE === 'development'
            ? 'http://192.168.100.114:1688/api'
            : 'https://api.datascape.indofungames.com',
});

// 请求拦截
instance.interceptors.request.use(
    (config) => {
        // 添加token（示例）
        const token = localStorage.getItem('token');
        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
        }

        // 可添加loading控制
        // console.log('请求配置:config', config);
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

// 响应拦截
instance.interceptors.response.use(
    (response) => {
        // 统一处理响应数据（假设后端返回 { code, data, message }）
        const { code, msg, message } = response.data || {};

        // code === 0 表示成功
        if (code === 0) {
            return response; // 直接返回业务数据
        } else {
            // 业务错误：使用 error 类型而不是 info
            const errorMsg = msg || message || '请求失败';
            notification.error({
                message: '请求失败',
                duration: 5,
                description: errorMsg,
            });
            return Promise.reject(new Error(errorMsg));
        }
    },
    (error) => {
        // 如果是取消请求的错误，静默处理，不显示错误提示
        const isCanceled =
            error.name === 'CanceledError' ||
            error.name === 'AbortError' ||
            error.code === 'ERR_CANCELED' ||
            (error.message && (
                error.message.includes('canceled') ||
                error.message.includes('aborted')
            )) ||
            (axios.isCancel && axios.isCancel(error));

        if (isCanceled) {
            return Promise.reject(error);
        }

        // 处理HTTP错误和网络错误
        if (error.response) {
            // 服务器返回了响应，但状态码不在 2xx 范围内
            const { status, data } = error.response;
            const errorMsg = data?.msg || data?.message || error.message || '请求失败';

            if (status === 401) {
                // 未授权，需要登录
                message.error('登录信息已过期，请重新登录！');
                const { search, pathname } = window.location;
                const urlParams = new URL(window.location.href).searchParams;
                const redirect = urlParams.get('redirect');
                if (window.location.pathname !== '/user/login' && !redirect) {
                    const query = Qs.stringify({
                        redirect: pathname + search,
                    });
                    history.replace(`/user/login${query ? `?${query}` : ''}`);
                }
            } else if (status === 403) {
                // 禁止访问
                message.error('没有权限访问该资源！');
            } else if (status === 404) {
                notification.error({
                    message: '请求失败',
                    duration: 5,
                    description: '请求的资源不存在',
                });
            } else if (status >= 500) {
                notification.error({
                    message: '服务器错误',
                    duration: 5,
                    description: '服务器内部错误，请稍后重试',
                });
            } else {
                // 其他 HTTP 错误
                notification.error({
                    message: `请求失败 (${status})`,
                    duration: 5,
                    description: errorMsg,
                });
            }
        } else if (error.request) {
            // 请求已发出，但没有收到响应（网络错误、超时等）
            if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
                notification.error({
                    message: '请求超时',
                    duration: 5,
                    description: '请求超时，请检查网络连接后重试',
                });
            } else {
                notification.error({
                    message: '网络错误',
                    duration: 5,
                    description: '网络连接异常，请检查网络后重试',
                });
            }
        } else {
            // 请求配置出错
            notification.error({
                message: '请求配置错误',
                duration: 5,
                description: error.message || '请求配置有误，请检查后重试',
            });
        }

        return Promise.reject(error);
    },
);

// function throwErrorPromise(error) {
//   return Promise.reject(error);
// }

// function throwResponseErorrPromise(error) {
//   if (error && error.response) {
//     const { status } = error.response;
//     if (status === 401) {
//       return { code: 1, message: '用户信息未认证', data: null };
//     } else if (status === 403) {
//       return { code: 1, message: '用户信息未认证', data: null };
//     }
//   }
//   return Promise.reject(error);
// }

// let interceptorParamsId = axiosInstance.interceptors.request.use(
//   useRequestParams,
//   throwErrorPromise,
// );

// let interceptorEnvId = axiosInstance.interceptors.request.use(
//   useRequestEnvironment,
//   throwErrorPromise,
// );

// let interceptorResDataId = axiosInstance.interceptors.response.use(
//   useResponseData,
//   throwResponseErorrPromise,
// );
// let interceptorAutoLoginId = axiosInstance.interceptors.response.use(
//   useResponseAutoLogin,
//   throwResponseErorrPromise,
// );

// // 定义一个函数来移除所有拦截器
// function removeAllInterceptors() {
//   // 移除所有请求拦截器
//   axiosInstance.interceptors.request.eject(interceptorParamsId);
//   axiosInstance.interceptors.request.eject(interceptorEnvId);
//   // 移除所有响应拦截器
//   axiosInstance.interceptors.response.eject(interceptorResDataId);
//   axiosInstance.interceptors.response.eject(interceptorAutoLoginId);
// }

// export { removeAllInterceptors };

export default instance;
